import React, { useState } from "react";
import styles from "./StudentSchedule.module.css";
import Dropdown from "../../components/Dropdown/Dropdown";
import StudentTimeTable from "../../components/StudentTimeTable/StudentTimeTable";
import { FiUpload } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";


// 👇 Replace this with your actual holiday list if needed
const holidays = ["2025-07-04"]; // format: YYYY-MM-DD

const mockData = [
  {
    icon: "https://cdn-icons-png.flaticon.com/512/742/742751.png",
    heading: "Todays Mood",
    title: "Lunch",
    staff: "Darshan Sir",
    time: "3:30 PM to 4:30 PM",
  },
  {
    icon: "https://cdn-icons-png.flaticon.com/512/742/742751.png",
    heading: "Todays Mood",
    title: "Lunch",
    staff: "Darshan Sir",
    time: "3:30 PM to 4:30 PM",
  },
  {
    icon: "https://cdn-icons-png.flaticon.com/512/742/742751.png",
    heading: "Todays Mood",
    title: "Lunch",
    staff: "Darshan Sir",
    time: "3:30 PM to 4:30 PM",
  },
  {
    icon: "https://cdn-icons-png.flaticon.com/512/742/742751.png",
    heading: "Todays Mood",
    title: "Lunch",
    staff: "Darshan Sir",
    time: "3:30 PM to 4:30 PM",
  },
];

const StudentSchedule = () => {

  const dispatch = useDispatch();

  const [selectedDate, setSelectedDate] = useState("");
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth(); // 0-indexed
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const getDayName = (dateStr) =>
    new Date(dateStr).toLocaleDateString("en-US", { weekday: "short" });

  const getFormattedDate = (day) => {
    const date = new Date(year, month, day);
    return date.toLocaleDateString("en-CA"); // ✅ Fix for timezone offset issue
  };
  

  const isHoliday = (dateStr) => holidays.includes(dateStr);
  const isSunday = (day) => new Date(year, month, day).getDay() === 0;

  return (
    <div className={styles.pageWrapper}>
      {/* LEFT */}
      <div className={styles.leftColumn}>
        <div className={styles.filterWrapper}>
          <Dropdown label=" Staff" options={["Darshan Sir", "Other"]} />
          <Dropdown label="Rooms" options={["Room A", "Room B"]} />
        </div>

        <div className={styles.cardGrid}>
          {mockData.map((item, index) => (
            <StudentTimeTable
              key={index}
              icon={item.icon}
              heading={item.heading}
              title={item.title}
              staff={item.staff}
              time={item.time}
              onEdit={() => console.log("Edit clicked", index)}
              onDelete={() => console.log("Delete clicked", index)}
            />
          ))}
        </div>
      </div>

      {/* RIGHT */}
      {/* RIGHT */}
      <div className={styles.rightColumn}>
        <div className={styles.customCalendar}>
          <div className={styles.calendarHeader}>
            <span>{selectedDate ? `Selected: ${selectedDate}` : "Date"}</span>
          </div>

          {/* Weekday Headings */}
          <div className={styles.weekdays}>
            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day, i) => (
              <div key={i} className={styles.weekday}>
                {day}
              </div>
            ))}
          </div>

          {/* Calendar Days */}
          <div className={styles.calendarGrid}>
            {(() => {
              const firstDayIndex = new Date(year, month, 1).getDay();
              const placeholders = Array.from(
                { length: firstDayIndex },
                (_, i) => (
                  <div key={`ph-${i}`} className={styles.placeholder}></div>
                )
              );

              const days = Array.from({ length: daysInMonth }, (_, i) => {
                const day = i + 1;
                const dateStr = getFormattedDate(day);
                const dayOfWeek = new Date(year, month, day).getDay();
                const isHolidayDate = isHoliday(dateStr);
                const isSun = dayOfWeek === 0;
                const isSelected = selectedDate === dateStr;

                return (
                  <div
                    key={day}
                    className={`${styles.dateCell} ${
                      isSelected ? styles.selected : ""
                    }`}
                    onClick={() => setSelectedDate(dateStr)}
                    style={{
                      color: isHolidayDate
                        ? "var(--Warning_Color)"
                        : isSun
                        ? "var(--Primary_Color)"
                        : "",
                    }}
                  >
                    {String(day).padStart(2, "0")}
                  </div>
                );
              });

              return [...placeholders, ...days];
            })()}
          </div>
        </div>

        {/* Buttons */}
        <button
          className={styles.addSchedule}
          onClick={() => dispatch(openModal("addScheduleItem"))}
        >
          Add Schedule
        </button>

        <div
          className={styles.bulkUpload}
          onClick={() => console.log("Bulk upload/Delete clicked")}
        >
          <FiUpload size={14} />
          <span>Bulk upload / Delete</span>
        </div>
      </div>
    </div>
  );
};

export default StudentSchedule;
